import {StructureBuilder, StructureResolverContext} from 'sanity/structure'
import {BiVideo} from 'react-icons/bi'
import {FiAlertCircle} from 'react-icons/fi'
import {map} from 'rxjs/operators'

export default function videosStructure(S: StructureBuilder, context: StructureResolverContext) {
  const videoSchemaType = 'blog.video'
  const clusterSchemaType = 'blog.category-cluster'
  const categorySchemaType = 'blog.category'

  const client = context.getClient({apiVersion: '2025-01-01'})

  return S.listItem()
    .title('Videos')
    .icon(BiVideo)
    .child(
      S.list()
        .title('Videos')
        .items([
          // All videos
          S.listItem()
            .title('All Videos')
            .icon(BiVideo)
            .child(
              S.documentList()
                .title('All Videos')
                .schemaType(videoSchemaType)
                .filter(`_type == $type && !(_id in path("drafts.**"))`)
                .params({type: videoSchemaType}),
            ),

          // Draft videos
          S.listItem()
            .title('Draft Videos')
            .icon(BiVideo)
            .child(() =>
              client.observable
                .fetch(
                  `*[_type == $type && _id in path("drafts.**")] | order(_updatedAt desc) {
                    _id,
                    _type,
                    title,
                    _updatedAt
                  }`,
                  {type: videoSchemaType},
                )
                .pipe(
                  map((drafts) =>
                    S.list()
                      .title('Draft Videos')
                      .items(
                        drafts.map((draft: any) =>
                          S.documentListItem()
                            .id(draft._id)
                            .schemaType(videoSchemaType)
                            .title(draft.title || 'Untitled'),
                        ),
                      ),
                  ),
                ),
            ),

          S.listItem()
            .title('Videos without thumbnail')
            .icon(FiAlertCircle)
            .child(
              S.documentList()
                .title('Videos without thumbnail')
                .schemaType(videoSchemaType)
                .filter(`_type == $type && !defined(featuredMedia)`)
                .params({type: videoSchemaType}),
            ),

          S.listItem()
            .title('Videos with wrong category')
            .icon(FiAlertCircle)
            .child(
              S.documentList()
                .title('Videos with wrong category')
                .schemaType(videoSchemaType)
                .filter(`_type == $type && mainCategory->_type == "${clusterSchemaType}"`)
                .params({type: videoSchemaType}),
            ),

          S.listItem()
            .title('Videos without embed')
            .icon(FiAlertCircle)
            .child(
              S.documentList()
                .title('Videos without embed')
                .schemaType(videoSchemaType)
                .filter(`_type == $type && !defined(video)`)
                .params({type: videoSchemaType}),
            ),

          S.listItem()
            .title('Videos without tags')
            .icon(FiAlertCircle)
            .child(
              S.documentList()
                .title('Videos without tags')
                .schemaType(videoSchemaType)
                .filter(`_type == $type && count(tags) == 0`)
                .params({type: videoSchemaType}),
            ),

          S.divider({id: 'divider-by-cluster', type: 'divider', title: 'By Cluster'}),

          // Videos by cluster
          S.listItem()
            .title('Videos by cluster')
            .icon(BiVideo)
            .child(
              S.documentList()
                .title('Category Clusters')
                .schemaType(clusterSchemaType)
                .filter(`_type == "${clusterSchemaType}"`)
                .child((clusterId) =>
                  S.documentList()
                    .title('Videos')
                    .schemaType(videoSchemaType)
                    .filter(
                      `_type == "${videoSchemaType}" && mainCategory->cluster._ref == $clusterId`,
                    )
                    .params({clusterId}),
                ),
            ),

          S.listItem()
            .title('Videos by category')
            .icon(BiVideo)
            .child(
              S.documentList()
                .title('Category')
                .schemaType(categorySchemaType)
                .filter(`_type == "${categorySchemaType}"`)
                .defaultOrdering([{field: 'title', direction: 'asc'}])
                .child((categoryId) =>
                  S.documentList()
                    .title('Videos')
                    .schemaType(videoSchemaType)
                    .filter(`_type == "${videoSchemaType}" && mainCategory._ref == $categoryId`)
                    .params({categoryId}),
                ),
            ),
        ]),
    )
}
